export const isValidArray = (data) => {
    return data && Array.isArray(data) && data.length > 0;
};